module.exports = __webpack_public_path__ + "static/media/food truck mafia logo new.aa649912.png";


//////////////////
// WEBPACK FOOTER
// ./src/mockAPI/images/food truck mafia logo new.png
// module id = 269
// module chunks = 0